export default __webpack_public_path__ + "static/media/m-eggplant.f7deb464.png";